import { HsControlActionType } from './control-action-type.enum';

export abstract class HsControlAction {
  public isActive: boolean = false;
  public actionType: HsControlActionType = HsControlActionType.None;

  public abstract getValuesFrom(controlAction: HsControlAction): void;
  public setInactive(): void {
    this.isActive = false;
  }
}
